import React, { FC, useEffect, useRef } from 'react'

import { useFormContext } from 'react-hook-form'

import { useCustomer } from 'Hooks/checkout'
import squareInputStyles from 'Utils/squareInputStyles'

import ErrorMessage from 'Components/ErrorMessage'
import FormErrors from 'Components/FormErrors'
import CreditCard from 'Components/Square/CreditCard'

import { usePayment } from '../../Provider'

interface Props {
  isActive: boolean
}

const SquarePaymentFields: FC<Props> = ({ isActive }) => {
  const { setPaymentStatus } = usePayment()
  const customer = useCustomer()

  const { register } = useFormContext()

  const cardResizeRef = useRef<() => void>()
  useEffect(() => {
    if (isActive) cardResizeRef.current?.()
  }, [isActive])
  useEffect(() => {
    const onResize = () => {
      if (isActive) cardResizeRef.current?.()
    }

    window.addEventListener('resize', onResize)
    return () => window.addEventListener('resize', onResize)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    register('squarePayment.verificationToken')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="checkout-card" id="form-container">
      <div className="checkout-card__body">
        <CreditCard cardResizeRef={cardResizeRef} setPaymentStatus={setPaymentStatus} style={squareInputStyles()} />
        {customer?.signedUp ? (
          <div className="custom-control / custom-checkbox / mt-1">
            <input
              ref={register}
              className="custom-control-input"
              id="save-card"
              name="squarePayment.saveCard"
              type="checkbox"
            />
            <label className="custom-control-label" htmlFor="save-card">
              Save card information for future purchases
            </label>
          </div>
        ) : null}

        <ErrorMessage as={FormErrors} name="squarePayment.sourceId" />
      </div>
    </div>
  )
}

export default SquarePaymentFields
